"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    breakpoints: [
        // 0
        "576px",
        "768px",
        "992px",
        "1200px",
        "1600px"
    ],
    space: [
        0,
        8,
        16,
        24,
        32,
        40,
        48,
        64,
        128 // 8
    ],
    sizes: [
        0,
        8,
        16,
        24,
        32,
        40,
        48,
        64,
        128 // 8
    ]
};
